import { SCREENS } from 'src/constants/screens';
import { USER_ROLES } from 'src/constants/user';
import { IScreenTab } from 'src/view/containers/ScreenTabsNavigation/ScreenTabsNavigation';
import { appStore } from '~/mobx/appStore';

export const menuManagementNavigation = (): IScreenTab[] => {
  const screens = [
    { path: SCREENS.MENU_GROUPS(), title: 'menu_groups', accessRoles: [USER_ROLES.RESTAURANT_MANAGER, USER_ROLES.MARKETING] },
    { path: SCREENS.CATEGORIES(), title: 'categories', accessRoles: [USER_ROLES.RESTAURANT_MANAGER] },
    { path: SCREENS.ITEMS(), title: 'items', accessRoles: [USER_ROLES.RESTAURANT_MANAGER] },
    { path: SCREENS.MODIFIERS(), title: 'modifiers', accessRoles: [USER_ROLES.RESTAURANT_MANAGER] },
    { path: SCREENS.EXCLUSIONS(), title: 'Exclusions', accessRoles: [USER_ROLES.RESTAURANT_MANAGER] },
    {
      path: SCREENS.MEALS(),
      title: 'combo_meal_tab',
      visible: appStore.isAddonsAvailable.meals,
      accessRoles: [USER_ROLES.RESTAURANT_MANAGER, USER_ROLES.MARKETING],
    },
  ];

  return screens;
};
